import { createContext, useContext } from 'react';

const DmdillyContext = createContext(null);

export function DmdillyProvider({ children, apiBaseUrl, creatorId, guideInfo }) {
  const value = {
    apiBaseUrl: apiBaseUrl || '',
    creatorId: creatorId || '',
    guideInfo: guideInfo || null,
  };

  return (
    <DmdillyContext.Provider value={value}>
      {children}
    </DmdillyContext.Provider>
  );
}

export function useDmdilly() {
  const context = useContext(DmdillyContext);
  if (!context) {
    throw new Error('useDmdilly must be used within a DmdillyProvider');
  }
  return context;
}

export default DmdillyContext;
